import React from 'react';
import { Link } from 'react-router-dom';

const WorkNavigation = ({ navigation }) => {
  const { prev, next } = navigation;

  return (
    <section className="mb-12">
      <div className="flex flex-col space-y-6">
        {/* Progress indicator */}
        {/* <div className="text-center">
          <span className="text-sm text-base-content/60">
            {currentIndex} of {total} work items
          </span>
        </div> */}
        
        {/* Navigation buttons */}
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          {prev ? (
            <Link 
              to={prev.link}
              className="group flex items-center space-x-3 p-4 bg-base-100 rounded-lg hover:shadow-md transition-all duration-200 w-full md:w-auto"
            >
              <div className="text-orange-500 group-hover:text-orange-600">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </div>
              <div className="text-left">
                <div className="text-xs text-base-content/60 uppercase tracking-wide">Previous</div>
                <div className="font-medium text-sm">{prev.title}</div>
              </div>
            </Link>
          ) : (
            <div className="w-full md:w-auto"></div>
          )}
          
          {next ? (
            <Link 
              to={next.link}
              className="group flex items-center space-x-3 p-4 bg-base-100 rounded-lg hover:shadow-md transition-all duration-200 w-full md:w-auto"
            >
              <div className="text-right flex-1">
                <div className="text-xs text-base-content/60 uppercase tracking-wide">Next</div>
                <div className="font-medium text-sm">{next.title}</div>
              </div>
              <div className="text-orange-500 group-hover:text-orange-600">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </Link>
          ) : (
            <div className="w-full md:w-auto"></div>
          )}
        </div>
      </div>
    </section>
  );
};

export default WorkNavigation; 